import { createClient } from '@/shared/api';
import type {
  AssignDeviceToStudyMutation,
  AssignDeviceToStudyMutationVariables,
} from '@/shared/api';
import ASSIGN_DEVICE_TO_STUDY_MUTATION from '../mutations/assignDeviceToStudy';

/**
 * Assigns a device to a study so recording can begin. Runs ASSIGN_DEVICE_TO_STUDY_MUTATION, throws the returned message when isSuccess is false, and returns the updated study.
 *
 * @param input - Mutation input payload.
 * @returns The study after the device assignment.
 */
const handleAssignDeviceToStudy = async (
  input: AssignDeviceToStudyMutationVariables['input'],
): Promise<NonNullable<AssignDeviceToStudyMutation['assignDeviceToStudy']>['study']> => {
  const client = createClient();
  const result = await client.mutate<
    AssignDeviceToStudyMutation,
    AssignDeviceToStudyMutationVariables
  >({
    mutation: ASSIGN_DEVICE_TO_STUDY_MUTATION,
    variables: {
      input,
    },
  });
  if (!result?.data?.assignDeviceToStudy?.isSuccess) {
    throw new Error(result?.data?.assignDeviceToStudy?.message ?? undefined);
  }
  return result?.data?.assignDeviceToStudy?.study;
};

export default handleAssignDeviceToStudy;
